import { createSelector } from '@reduxjs/toolkit';
import {
  getVimeoId,
  getYoutubeThumbnail,
  getYoutubeThumbnailSafe,
} from '../components/video-player/video-util';
import type { RootState } from '../reducers';

const getVimeoThumbnail = (vimeoId: string, thumbnails: { [key: string]: string | undefined }) => {
  const match = thumbnails[vimeoId];
  if (match && match.indexOf('_') >= 0) {
    return `${match.substring(0, match.indexOf('_'))}_820x.jpg`;
  } else if (thumbnails[vimeoId]) {
    return thumbnails[vimeoId];
  }
  return '';
};

const getVimeoThumbnailSafe = (
  vimeoId: string,
  thumbnails: { [key: string]: string | undefined },
) => {
  if (Object.hasOwn(thumbnails, vimeoId) && thumbnails[vimeoId]) {
    return thumbnails[vimeoId];
  }

  return '';
};

export const getEmbededThumbnail = createSelector(
  (state: RootState) => state.vimeo.thumbnails,
  (_: RootState, ownProps: { url?: string }) => ownProps.url,
  (thumbnails, url) => {
    if (url) {
      const vimeoId = getVimeoId(url);
      if (vimeoId) {
        return getVimeoThumbnail(vimeoId, thumbnails);
      } else if (getYoutubeThumbnail(url)) {
        return getYoutubeThumbnail(url);
      }
    }
    return null;
  },
);

export const getEmbededThumbnailSafe = createSelector(
  (state: RootState) => state.vimeo.thumbnails,
  (_: RootState, ownProps: { url?: string }) => ownProps.url,
  (thumbnails, url) => {
    if (url) {
      const vimeoId = getVimeoId(url);
      if (vimeoId) {
        return getVimeoThumbnailSafe(vimeoId, thumbnails);
      } else if (getYoutubeThumbnailSafe(url)) {
        return getYoutubeThumbnailSafe(url);
      }
    }
    return null;
  },
);
